"use client";

import { cn } from "@oreme/ui";
import { cva } from "class-variance-authority";
import React, { type ReactElement } from "react";
import { GlobalApplicationCard } from "@/components";
import { motion } from "motion/react";
import { primaryApplications } from "@/services/applications";

const sectionListItemVariants = cva(
  "flex flex-col transform transition-transform scale-100 hover:drop-shadow-lg hover:-translate-y-2 hover:scale-102",
);

function MoreSectionPrimary(): ReactElement {
  const animation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <section>
      <div className="relative max-w-7xl mx-auto flex flex-col py-12">
        <ul className="relative z-20 grid gap-4 px-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          {primaryApplications.map((application) => {
            return (
              <motion.li
                key={application.id}
                className={cn(sectionListItemVariants())}
                initial={animation.initial}
                animate={animation.animate}
                transition={{
                  duration: 0.4,
                  delay: 0,
                  scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                }}
                whileInView="onscreen"
              >
                <GlobalApplicationCard application={application} />
              </motion.li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export { MoreSectionPrimary };
